function initProduct(section) {
    if (!section || section.dataset.initialized) return;
    section.dataset.initialized = 'true';

    const form = section.querySelector('[data-product-form]');
    if (!form) return;

    const productJsonEl = section.querySelector('[data-product-json]');
    const productStringsEl = section.querySelector('[data-product-strings]');
    
    if (!productJsonEl || !productStringsEl) return;

    const productJson = JSON.parse(productJsonEl.textContent);
    const productStrings = JSON.parse(productStringsEl.textContent);
    const variantIdInput = section.querySelector('[data-variant-id]');
    const priceEl = section.querySelector('[data-product-price]');
    const comparePriceEl = section.querySelector('[data-product-compare-price]');
    const saleBadgeEl = section.querySelector('[data-product-sale-badge]');
    const saveBadgeEl = section.querySelector('[data-product-save-badge]');
    const unitPriceEl = section.querySelector('[data-product-unit-price]');
    const skuEl = section.querySelector('[data-sku-value]');
    const availabilityEl = section.querySelector('[data-product-availability]');
    const addBtn = section.querySelector('[data-add-to-cart]');
    const thumbnails = section.querySelectorAll('[data-thumbnail-button]');
    const optionInputs = section.querySelectorAll('[data-option-input]');
    const mediaItems = section.querySelectorAll('.product__media-item');

    var formatMoney = Shopify.formatMoney;

    function updateVariant() {
      const selectedOptions = [];
      productJson.options.forEach(function(opt, index) {
        const input = form.querySelector('input[name="option' + (index + 1) + '"]:checked');
        if (input) selectedOptions.push(input.value);
      });

      const matchedVariant = productJson.variants.find(function(variant) {
        return variant.options.length === selectedOptions.length &&
               variant.options.every(function(val, index) {
                 return val === selectedOptions[index];
               });
      });

      if (matchedVariant) {
        variantIdInput.value = matchedVariant.id;

        priceEl.textContent = formatMoney(matchedVariant.price);

        if (comparePriceEl && saleBadgeEl) {
          if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            comparePriceEl.textContent = formatMoney(matchedVariant.compare_at_price);
            comparePriceEl.style.display = '';
            saleBadgeEl.style.display = 'none';
            if (saveBadgeEl) {
              var savedAmt = matchedVariant.compare_at_price - matchedVariant.price;
              saveBadgeEl.textContent = 'Save ' + formatMoney(savedAmt);
              saveBadgeEl.style.display = '';
            }
          } else {
            comparePriceEl.style.display = 'none';
            saleBadgeEl.style.display = 'none';
            if (saveBadgeEl) saveBadgeEl.style.display = 'none';
          }
        }

        if (unitPriceEl) {
          if (matchedVariant.unit_price_measurement) {
            var referenceValue = matchedVariant.unit_price_measurement.reference_value;
            var referenceUnit = matchedVariant.unit_price_measurement.reference_unit;
            var unitPriceText = formatMoney(matchedVariant.unit_price) + ' / ';
            if (referenceValue && referenceValue !== 1) {
              unitPriceText += referenceValue + ' ';
            }
            unitPriceText += referenceUnit;
            unitPriceEl.textContent = unitPriceText;
            unitPriceEl.style.display = '';
          } else {
            unitPriceEl.textContent = '';
            unitPriceEl.style.display = 'none';
          }
        }

        if (skuEl) {
          skuEl.textContent = matchedVariant.sku || '';
        }

        if (availabilityEl) {
          if (matchedVariant.available) {
            availabilityEl.textContent = productStrings.inStock;
            availabilityEl.className = 'product__availability product__availability--in-stock';
          } else {
            availabilityEl.textContent = productStrings.outOfStock;
            availabilityEl.className = 'product__availability product__availability--out-of-stock';
          }
        }

        if (matchedVariant.available) {
          addBtn.disabled = false;
          addBtn.textContent = productStrings.addToCart;
        } else {
          addBtn.disabled = true;
          addBtn.textContent = productStrings.soldOut;
        }

        const url = new URL(window.location);
        url.searchParams.set('variant', matchedVariant.id);
        history.replaceState({}, '', url);

        if (matchedVariant.featured_media) {
          switchMedia(matchedVariant.featured_media.id);
        }

        productJson.options.forEach(function(opt, index) {
          const valueSpan = section.querySelector('[data-option-value="' + (index + 1) + '"]');
          if (valueSpan) valueSpan.textContent = selectedOptions[index];
        });

        // 触发自定义事件,通知 Sticky Bar 同步
        document.dispatchEvent(new CustomEvent('variant:changed', {
          detail: { variant: matchedVariant }
        }));

      } else {
        addBtn.disabled = true;
        addBtn.textContent = productStrings.unavailable;
      }
    }

    function switchMedia(mediaId) {
      mediaItems.forEach(function(item) {
        const isActive = item.dataset.mediaId == mediaId;
        item.classList.toggle('is-active', isActive);

        if (!isActive) {
          const video = item.querySelector('video');
          if (video) video.pause();
        }
      });

      thumbnails.forEach(function(thumb) {
        const isActive = thumb.dataset.mediaId == mediaId;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        switchMedia(thumb.dataset.mediaId);
      });
    });

    optionInputs.forEach(function(input) {
      input.addEventListener('change', updateVariant);
    });

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const formData = new FormData(form);
      const submitBtn = form.querySelector('[data-add-to-cart]');
      const originalText = submitBtn.textContent;

      submitBtn.disabled = true;
      submitBtn.textContent = productStrings.adding;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if (data.status === 422) {
          submitBtn.textContent = data.description || productStrings.error;
          setTimeout(function() {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        } else {
          submitBtn.textContent = productStrings.added;
          setTimeout(function() {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 1500);

          fetch('/cart.js')
            .then(function(res) { return res.json(); })
            .then(function(cart) {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
            });
        }
      })
      .catch(function(error) {
        console.error('Add to cart error:', error);
        submitBtn.textContent = productStrings.error;
        setTimeout(function() {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 2000);
      });
    });

    const quantityInput = section.querySelector('.product__quantity-input');
    const minusBtn = section.querySelector('[data-quantity-minus]');
    const plusBtn = section.querySelector('[data-quantity-plus]');

    if (minusBtn && plusBtn && quantityInput) {
      minusBtn.addEventListener('click', function() {
        const currentVal = parseInt(quantityInput.value) || 1;
        if (currentVal > 1) {
          quantityInput.value = currentVal - 1;
        }
      });

      plusBtn.addEventListener('click', function() {
        const currentVal = parseInt(quantityInput.value) || 1;
        quantityInput.value = currentVal + 1;
      });
    }

    const zoomContainers = section.querySelectorAll('[data-zoom-container]');

    zoomContainers.forEach(function(container) {
      const img = container.querySelector('img');
      let isZoomed = false;

      container.addEventListener('click', function(e) {
        if (!isZoomed) {
          container.classList.add('is-zoomed');
          isZoomed = true;
          updateZoomPosition(e, container, img);
        } else {
          container.classList.remove('is-zoomed');
          isZoomed = false;
          img.style.transformOrigin = '';
        }
      });

      container.addEventListener('mousemove', function(e) {
        if (isZoomed) {
          updateZoomPosition(e, container, img);
        }
      });

      container.addEventListener('mouseleave', function() {
        if (isZoomed) {
          container.classList.remove('is-zoomed');
          isZoomed = false;
          img.style.transformOrigin = '';
        }
      });
    });

    function updateZoomPosition(e, container, img) {
      const rect = container.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    }

    // Accessory add-to-cart
    section.querySelectorAll('[data-accessory-add]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = btn.getAttribute('data-accessory-add');
        if (!variantId) return;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.status === 422) {
            btn.disabled = false;
            return;
          }
          btn.classList.add('product__accessory-atc--added');
          setTimeout(function() {
            btn.classList.remove('product__accessory-atc--added');
            btn.disabled = false;
          }, 1500);
          fetch('/cart.js')
            .then(function(res) { return res.json(); })
            .then(function(cart) {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
            });
        })
        .catch(function() {
          btn.disabled = false;
        });
      });
    });

    // Coupon copy
    section.querySelectorAll('[data-coupon-copy]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var code = btn.getAttribute('data-coupon-copy');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function() {
            btn.classList.add('product__coupon-code--copied');
            var label = btn.querySelector('[data-coupon-label]');
            var original = label.textContent;
            label.textContent = '✓ Copied';
            setTimeout(function() {
              btn.classList.remove('product__coupon-code--copied');
              label.textContent = original;
            }, 1500);
          });
        }
      });
    });

    const thumbContainer = section.querySelector('.product__thumbnails');
    if (thumbContainer) {
      thumbContainer.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          const thumbsArray = Array.from(thumbnails);
          const currentIndex = thumbsArray.findIndex(function(t) {
            return t.classList.contains('is-active');
          });
          let nextIndex;

          if (e.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % thumbsArray.length;
          } else {
            nextIndex = (currentIndex - 1 + thumbsArray.length) % thumbsArray.length;
          }

          thumbsArray[nextIndex].click();
          thumbsArray[nextIndex].focus();
        }
      });
    }

    // Mobile touch swipe support for gallery
    const mainImageWrapper = section.querySelector('[data-product-main-image-wrapper]');
    if (mainImageWrapper && mediaItems.length > 1) {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;
      const minSwipeDistance = 50;
      const maxVerticalDistance = 100;

      function getCurrentMediaIndex() {
        const mediaArray = Array.from(mediaItems);
        return mediaArray.findIndex(function(item) {
          return item.classList.contains('is-active');
        });
      }

      function switchToIndex(index) {
        const mediaArray = Array.from(mediaItems);
        if (index >= 0 && index < mediaArray.length) {
          const targetMediaId = mediaArray[index].dataset.mediaId;
          switchMedia(targetMediaId);
        }
      }

      mainImageWrapper.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });

      mainImageWrapper.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;

        const horizontalDistance = touchEndX - touchStartX;
        const verticalDistance = Math.abs(touchEndY - touchStartY);

        // Only trigger swipe if horizontal movement is significant and vertical is minimal
        if (Math.abs(horizontalDistance) > minSwipeDistance && verticalDistance < maxVerticalDistance) {
          const currentIndex = getCurrentMediaIndex();
          const mediaArray = Array.from(mediaItems);

          if (horizontalDistance < 0) {
            // Swipe left - next image
            const nextIndex = (currentIndex + 1) % mediaArray.length;
            switchToIndex(nextIndex);
          } else {
            // Swipe right - previous image
            const prevIndex = (currentIndex - 1 + mediaArray.length) % mediaArray.length;
            switchToIndex(prevIndex);
          }
        }
      }, { passive: true });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const productSections = document.querySelectorAll('.product-section');
    productSections.forEach(initProduct);
  });

  document.addEventListener('shopify:section:load', (e) => {
    const productSection = e.target.querySelector('.product-section');
    if (productSection) initProduct(productSection);
  });

  // ── Flash Sale Countdown (循环倒计时) ────────────────────────────────
  (function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function(el) {
      var totalHours = parseFloat(el.getAttribute('data-hours')) || 24;
      var totalMs = totalHours * 3600 * 1000;

      // Use sessionStorage so countdown persists on page refresh but resets per session
      var storageKey = 'kingride_countdown_end_' + totalHours;
      var now = Date.now();
      var endTime = parseInt(sessionStorage.getItem(storageKey) || '0', 10);

      // 每次新会话或倒计时结束，重置
      if (!endTime || endTime <= now) {
        endTime = now + totalMs;
        sessionStorage.setItem(storageKey, String(endTime));
      }

      var daysEl    = el.querySelector('[data-countdown-days]');
      var hoursEl   = el.querySelector('[data-countdown-hours]');
      var minutesEl = el.querySelector('[data-countdown-minutes]');
      var secondsEl = el.querySelector('[data-countdown-seconds]');

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function tick() {
        var remaining = endTime - Date.now();
        if (remaining <= 0) {
          // Reset: start a new cycle
          endTime = Date.now() + totalMs;
          sessionStorage.setItem(storageKey, String(endTime));
          remaining = totalMs;
        }
        var totalSecs = Math.floor(remaining / 1000);
        var days    = Math.floor(totalSecs / 86400);
        var hours   = Math.floor((totalSecs % 86400) / 3600);
        var minutes = Math.floor((totalSecs % 3600) / 60);
        var seconds = totalSecs % 60;

        if (daysEl)    daysEl.textContent    = pad(days);
        if (hoursEl)   hoursEl.textContent   = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      tick();
      setInterval(tick, 1000);
    });
  })();

  // ── 隐藏 PayPal 等品牌动态结账按钮 ──────────────────────────────────
  (function hidePayPalButton() {
    function doHide() {
      document.querySelectorAll(
        '.shopify-payment-button__button--branded, [data-testid*="paypal"], [data-shopify-buttoncontainer] iframe'
      ).forEach(function(el) {
        var container = el.closest('.shopify-payment-button__button--branded') || el;
        container.style.setProperty('display', 'none', 'important');
      });
      // Also hide More payment options link if PayPal was the only branded option
      var moreLink = document.querySelector('.shopify-payment-button__more-options');
      if (moreLink) moreLink.style.setProperty('display', 'none', 'important');
    }
    doHide();
    setTimeout(doHide, 500);
    setTimeout(doHide, 1500);
    setTimeout(doHide, 3000);
    // Watch for dynamic injection
    var observer = new MutationObserver(doHide);
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  // (Bundle + Warranty + Accordion JS moved to inline <script> tag for immediate loading)

  // ════════════════════════════════════════════════════════════════════
  // ── Sticky Mobile Buy Bar (优化版 — 修复变体切换 bug) ──
  // ════════════════════════════════════════════════════════════════════
  (function initStickyBar() {
    var bar = document.getElementById('product-sticky-bar');
    var stickyBtn = bar ? bar.querySelector('[data-sticky-add-to-cart]') : null;
    var mainBtn = document.querySelector('[data-add-to-cart]');
    var mainForm = document.getElementById('ProductForm-Main');
    if (!bar || !mainBtn) return;

    // ── 1. 当主按钮滚出视口时显示 sticky bar ──
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          if (entry.boundingClientRect.top < 0) {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          }
        }
      });
    }, { threshold: 0 });

    observer.observe(mainBtn);

    // ── 2. sticky 按钮点击 → 触发主表单提交 ──
    if (stickyBtn && mainForm) {
      stickyBtn.addEventListener('click', function() {
        if (mainBtn.disabled) return;
        mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.submit();
      });
    }

    // ── 3. 提取所有 sticky bar 内的元素 ──
    var stickyPriceEl = bar.querySelector('.product__sticky-bar-price');
    var stickyComparePriceEl = bar.querySelector('.sticky-bar__price-was');
    var stickySaveTagEl = bar.querySelector('.sticky-bar__save-tag');
    var stickyGiftHintEl = bar.querySelector('.sticky-bar__gift-hint');

    // ── 4. 监听 option 变化,主动同步 sticky bar(修复 bug) ──
    var productJsonEl = document.querySelector('[data-product-json]');
    var optionInputs = document.querySelectorAll('[data-option-input]');

    if (productJsonEl && optionInputs.length > 0) {
      var productJson = JSON.parse(productJsonEl.textContent);

      function updateStickyBar() {
        var selectedOptions = [];
        productJson.options.forEach(function(opt, index) {
          var input = document.querySelector('input[name="option' + (index + 1) + '"]:checked');
          if (input) selectedOptions.push(input.value);
        });

        var matchedVariant = productJson.variants.find(function(variant) {
          return variant.options.length === selectedOptions.length &&
                 variant.options.every(function(val, index) {
                   return val === selectedOptions[index];
                 });
        });

        if (!matchedVariant) return;

        // 同步价格
        if (stickyPriceEl) {
          if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            stickyPriceEl.textContent = Shopify.formatMoney(matchedVariant.price);
          } else {
            stickyPriceEl.textContent = '€' + (matchedVariant.price / 100).toFixed(2).replace('.', ',');
          }
        }

        // 同步划线价
        if (stickyComparePriceEl) {
          if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
              stickyComparePriceEl.textContent = Shopify.formatMoney(matchedVariant.compare_at_price);
            }
            stickyComparePriceEl.style.display = '';
          } else {
            stickyComparePriceEl.style.display = 'none';
          }
        }

        // 同步 Save 徽章
        if (stickySaveTagEl) {
          if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            var saved = matchedVariant.compare_at_price - matchedVariant.price;
            if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
              stickySaveTagEl.textContent = '−' + Shopify.formatMoney(saved);
            }
            stickySaveTagEl.style.display = '';
            if (stickyGiftHintEl) stickyGiftHintEl.style.display = '';
          } else {
            stickySaveTagEl.style.display = 'none';
            if (stickyGiftHintEl) stickyGiftHintEl.style.display = 'none';
          }
        }

        // 同步按钮状态
        if (stickyBtn) {
          if (matchedVariant.available) {
            stickyBtn.disabled = false;
            var addToCartText = mainBtn.textContent.trim();
            if (addToCartText && addToCartText !== 'Sold Out') {
              stickyBtn.textContent = addToCartText;
            }
          } else {
            stickyBtn.disabled = true;
            stickyBtn.textContent = 'Sold Out';
          }
        }
      }

      // 监听每个 option 输入框
      optionInputs.forEach(function(input) {
        input.addEventListener('change', updateStickyBar);
      });

      // 初始化一次(确保首次加载就正确)
      updateStickyBar();
    }

    // ── 5. 保留原有的事件监听(兼容性) ──
    document.addEventListener('variant:changed', function(e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;
      if (stickyPriceEl && variant.price) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          stickyPriceEl.textContent = Shopify.formatMoney(variant.price);
        }
      }
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    });
  })();